import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Board } from '../models/board.model';

@Injectable({ providedIn: 'root' })
export class FirstInterviewService {

  public boards: Board[] = [];

  /**
   * Constructor
   */
  constructor(
    private firestore$: AngularFirestore
  ) {
  }


  /**
   * Get board
   *
   * @param year
   */
  getBoard(year: number): Observable<Board> {
    return this.firestore$.doc<Board>('first-interviews/' + year).valueChanges().pipe(take(1));
  }

  /**
   * Update the board
   *
   * @param board
   */
  updateBoard(board: Board): Observable<Board> {
    board.lastActivity = new Date();
    return new Observable(subscriber => {
      this.firestore$.collection<Board>('first-interviews').doc(board.id).update(board)
        .then(() => {
          subscriber.next(board);
          subscriber.complete();
        })
        .catch(error => {
          console.log('error', error);
        });
    });
  }

  getCard(year: string, id: string): Observable<any> {
    return new Observable<any>(subscriber => {
      this.getBoard(+year).subscribe(board => {

        let enter = false;
        board.lists.forEach(list => {

          const c: any = list.cards.find(f => f.id === id);

          if (c) {
            enter = true;
            c.extraBoardInfo = board;
            subscriber.next(c);
            subscriber.complete();
          }

        });

        if (!enter) {
          subscriber.next();
          subscriber.complete();
        }
      });
    });
  }
}
